/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDetectionCountResponse
 */
export interface ControlDetectionCountResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlDetectionCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the ControlDetectionCountResponse interface.
 */
export function instanceOfControlDetectionCountResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ControlDetectionCountResponseFromJSON(json: any): ControlDetectionCountResponse {
    return ControlDetectionCountResponseFromJSONTyped(json, false);
}

export function ControlDetectionCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDetectionCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function ControlDetectionCountResponseToJSON(value?: ControlDetectionCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}

